<template>
	<div>
		<h1>Options Shopping Cart</h1>
		<!-- TODO: ask about these two select boxes; they both loop over the same array!! -->
		<tooltip label="Item title" placement="right">
			<select
				v-model="commandResponse.resp_cart_title"
				name="resp_cart_title"
				v-validate="'required|min_value:1'"
				:class="{'form-control': true, 'is-invalid': errors.has('resp_cart_title')}"
			>
				<option :value="0" disabled>{{$t('choose item title')}}</option>
				<option
					v-for="id in Object.keys(vars_ids)"
					:value="id"
					:key="'item_title_'+id"
				>{{ vars_ids[id] }}</option>
			</select>
			<span
				v-if="errors.has('resp_cart_title')"
				class="help is-danger invalid-feedback"
			>{{ $t(errors.first('resp_cart_title')) }}</span>
		</tooltip>

		<tooltip label="Item quantity" placement="right">
			<select
				v-model="commandResponse.resp_cart_quantity"
				name="resp_cart_quantity"
				:class="{'form-control': true, 'is-invalid': errors.has('resp_cart_quantity')}"
			>
				<option :value="0" disabled>{{$t('choose item quantity')}}</option>
				<option
					v-for="id in Object.keys(vars_ids)"
					:value="id"
					:key="'item_quantity_'+id"
				>{{ vars_ids[id] }}</option>
			</select>
			<span
				v-if="errors.has('resp_cart_quantity')"
				class="help is-danger invalid-feedback"
			>{{ $t(errors.first('resp_cart_quantity')) }}</span>
		</tooltip>
	</div>
</template>

<script>
	import axios from 'axios';

	export default {
		props: ['commandResponse'],
		data() {
			return {
				vars_ids: {},
				command_id: 0,
			}
		},
		methods: {
			get_command_vars() {
				return new Promise((resolve) => {
					axios
						.post('/command_var/get_all/' + this.command_id, {}, {})
						.then((res) => {
							if (res.data.status == 1) {
								this.vars = res.data.data
								// map id to names
								for (var _var in res.data.data) {
									this.vars_ids[res.data.data[_var].var_id] = res.data.data[_var].var_name
								}
								// Set Sender Info options
								this.vars_ids_with_sender_vars = {
									...this.vars_ids,
									...this.$store.state.sender_info,
								}
								this.setAutoCompeleteSchema()
							}
							resolve('success')
						})
						.catch(() => resolve('error'))
				})
			},
		},
		mounted() {
			this.command_id = parseInt(this.$route.params.command_id)
			this.get_command_vars()
		},
	}
</script>

<style lang="scss" scoped>
</style>
